import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ActionComponent } from '../../../ui/api/action.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { ResultComponent } from '../../../ui/resut/result.component';

export namespace NWishlistShare {
    export const BLOCK_ID = 'wishlist-share';

    export type IBlock = ICmsBlock<IBlockData>;
    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;
    export interface IBlockDataContent {
        components: NICmsContentComponent.IData[];
    }

    export interface IFormData {
        sender_name?: string;
        recipient_name?: string;
        recipient_email?: string;
        message?: string;
    }
}
@Component({
    selector: 'wishlist-share',
    templateUrl: 'wishlist-share.html',
    standalone: true,
    imports: [
        TranslationModule,
        ICmsClientModule,
        FormsModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        MuiInputDirective,
        ActionComponent,
        ResultComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<WishlistShareComponent>({
    id: NWishlistShare.BLOCK_ID,
    block: {
        url: NWishlistShare.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Wishlist Share',
    description: 'Wishlist share component',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.components,
            key: 'components',
            title: 'Add component',
            itemName: 'component',
            required: false,
            default: []
        }
    ]
})
@DfCmsModal({
    id: NWishlistShare.BLOCK_ID,
    position: 'custom',
    name: 'Wishlist Share',
    config: {
        closeOnNavigation: true,
        maxWidth: '80vw',
        width: '650px',
        modalClass: 'bg-col-w p-a overflow-hidden'
    },
    priority: 30,
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeName => ['S', 'M', 'L', 'X']
})
export class WishlistShareComponent extends AbstractFormComponent<NWishlistShare.IFormData> implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NWishlistShare.IBlockDataContent;

    protected submitPath = 'wishlist/share';

    constructor(
        readonly injector: Injector,
        ref: ChangeDetectorRef,
        private modalRef: ModalRef<void>
    ) {
        super(ref);
    }

    protected close(): void {
        this.modalRef.close();
    }
}
